export default __webpack_public_path__ + "static/media/taxCalImg.c7a631f1.svg";